import axios from 'axios';
import Auth from '../../auth/auth';

export const workflowActions = {

  LOAD_CHANGES_REQUEST: 'WF_LOAD_CHANGES_REQUEST',
  LOAD_CHANGES_SUCCESS: 'WF_LOAD_CHANGES_SUCCESS',
  LOAD_CHANGES_FAILURE: 'WF_LOAD_CHANGES_FAILURE',

  APPLY_ACTION_REQUEST: 'WF_APPLY_ACTION_REQUEST',
  APPLY_ACTION_SUCCESS: 'WF_APPLY_ACTION_SUCCESS',
  APPLY_ACTION_FAILURE: 'WF_APPLY_ACTION_FAILURE',

  ROLLBACK_REQUEST: 'WF_ROLLBACK_REQUEST',
  ROLLBACK_SUCCESS: 'WF_ROLLBACK_SUCCESS',
  ROLLBACK_FAILURE: 'WF_ROLLBACK_FAILURE',

  RECHECK_SOURCE_REQUEST: 'WF_RECHECK_SOURCE_REQUEST',
  RECHECK_SOURCE_SUCCESS: 'WF_RECHECK_SOURCE_SUCCESS',
  RECHECK_SOURCE_FAILURE: 'WF_RECHECK_SOURCE_FAILURE',

  BULK_ACTION_REQUEST: 'WF_BULK_ACTION_REQUEST',
  BULK_ACTION_SUCCESS: 'WF_BULK_ACTION_SUCCESS',
  BULK_ACTION_FAILURE: 'WF_BULK_ACTION_FAILURE',

  LOAD_NOTIFICATIONS_REQUEST: 'WF_LOAD_NOTIFICATIONS_REQUEST',
  LOAD_NOTIFICATIONS_SUCCESS: 'WF_LOAD_NOTIFICATIONS_SUCCESS',
  LOAD_NOTIFICATIONS_FAILURE: 'WF_LOAD_NOTIFICATIONS_FAILURE',

  LOAD_UNREAD_COUNT_REQUEST: 'WF_LOAD_UNREAD_COUNT_REQUEST',
  LOAD_UNREAD_COUNT_SUCCESS: 'WF_LOAD_UNREAD_COUNT_SUCCESS',
  LOAD_UNREAD_COUNT_FAILURE: 'WF_LOAD_UNREAD_COUNT_FAILURE',

  MARK_READ_SUCCESS: 'WF_MARK_READ_SUCCESS',
  MARK_ALL_READ_SUCCESS: 'WF_MARK_ALL_READ_SUCCESS',

  LOAD_PERMISSIONS_REQUEST: 'WF_LOAD_PERMISSIONS_REQUEST',
  LOAD_PERMISSIONS_SUCCESS: 'WF_LOAD_PERMISSIONS_SUCCESS',
  LOAD_PERMISSIONS_FAILURE: 'WF_LOAD_PERMISSIONS_FAILURE',

  UPDATE_PERMISSIONS_SUCCESS: 'WF_UPDATE_PERMISSIONS_SUCCESS',

  LOAD_HISTORY_REQUEST: 'WF_LOAD_HISTORY_REQUEST',
  LOAD_HISTORY_SUCCESS: 'WF_LOAD_HISTORY_SUCCESS',
  LOAD_HISTORY_FAILURE: 'WF_LOAD_HISTORY_FAILURE',

  DOWNLOAD_AUDIT_REPORT_REQUEST: 'WF_DOWNLOAD_AUDIT_REPORT_REQUEST',
  DOWNLOAD_AUDIT_REPORT_SUCCESS: 'WF_DOWNLOAD_AUDIT_REPORT_SUCCESS',
  DOWNLOAD_AUDIT_REPORT_FAILURE: 'WF_DOWNLOAD_AUDIT_REPORT_FAILURE',

  DOWNLOAD_DETAILED_REPORT_REQUEST: 'WF_DOWNLOAD_DETAILED_REPORT_REQUEST',
  DOWNLOAD_DETAILED_REPORT_SUCCESS: 'WF_DOWNLOAD_DETAILED_REPORT_SUCCESS',
  DOWNLOAD_DETAILED_REPORT_FAILURE: 'WF_DOWNLOAD_DETAILED_REPORT_FAILURE',

  DOWNLOAD_SUMMARY_REPORT_REQUEST: 'WF_DOWNLOAD_SUMMARY_REPORT_REQUEST',
  DOWNLOAD_SUMMARY_REPORT_SUCCESS: 'WF_DOWNLOAD_SUMMARY_REPORT_SUCCESS',
  DOWNLOAD_SUMMARY_REPORT_FAILURE: 'WF_DOWNLOAD_SUMMARY_REPORT_FAILURE',
};

const auth = new Auth();
const {getAccessToken} = auth;

function authHeaders() {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-access-token': getAccessToken(),
  };
}

export function loadChanges({instanceId, schemaId, status, changeSource, view, page, limit} = {}) {
  return function(dispatch) {
    dispatch({type: workflowActions.LOAD_CHANGES_REQUEST});
    const params = new URLSearchParams();
    if (instanceId) params.append('instanceId', instanceId);
    if (schemaId) params.append('schemaId', schemaId);
    if (status) params.append('status', status);
    if (changeSource) params.append('changeSource', changeSource);
    if (view) params.append('view', view);
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/changes?${params}`, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.LOAD_CHANGES_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.LOAD_CHANGES_FAILURE, payload: error, error: true}));
  };
}

export function applyAction(requestId, action, comments) {
  return function(dispatch) {
    dispatch({type: workflowActions.APPLY_ACTION_REQUEST});
    axios.post(`${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}/action`,
        {action, comments},
        {headers: authHeaders()},
    )
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.APPLY_ACTION_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.APPLY_ACTION_FAILURE, payload: error, error: true}));
  };
}

export function rollbackAction(requestId, reason) {
  return function(dispatch) {
    dispatch({type: workflowActions.ROLLBACK_REQUEST});
    axios.post(`${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}/rollback`,
        {reason},
        {headers: authHeaders()},
    )
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.ROLLBACK_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.ROLLBACK_FAILURE, payload: error, error: true}));
  };
}

// On-demand "Check live DB" for a REJECTED request (#595). Returns the axios
// promise so the caller can reload the list once the recheck completes.
export function recheckSource(requestId) {
  return function(dispatch) {
    dispatch({type: workflowActions.RECHECK_SOURCE_REQUEST});
    return axios.post(`${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}/recheck-source`,
        {},
        {headers: authHeaders()},
    )
        .then((r) => r.data)
        .then((json) => {
          dispatch({type: workflowActions.RECHECK_SOURCE_SUCCESS, payload: json}); return json;
        })
        .catch((error) => {
          dispatch({type: workflowActions.RECHECK_SOURCE_FAILURE, payload: error, error: true}); throw error;
        });
  };
}

// Merged change-history timeline for the detail drawer (#595): drift + decisions
// + live checks. Returns the promise so the caller can store events in local state.
export function loadChangeTimeline(requestId) {
  return function() {
    return axios.get(`${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}/timeline`, {headers: authHeaders()})
        .then((r) => r.data);
  };
}

// Complete lifecycle timeline for one field (applied versions + drift/decisions/live
// checks) for the field-history drawer (#595). Returns the promise; caller stores the
// events in local state — does NOT dispatch into shared redux history.
export function loadFieldTimeline(schemaId, objectName, columnName, entityId) {
  return function() {
    const params = new URLSearchParams();
    if (schemaId) params.append('schemaId', schemaId);
    if (objectName) params.append('objectName', objectName);
    if (columnName) params.append('columnName', columnName);
    if (entityId) params.append('entityId', entityId);
    return axios.get(`${process.env.REACT_APP_API_URL}/workflow/fields/timeline?${params}`, {headers: authHeaders()})
        .then((r) => r.data);
  };
}

// RETURNS its promise, so the caller can report what actually happened. Since slice 5j a bulk action
// no longer succeeds or fails as a unit: each request goes through the same live-source-checked path
// as a single approval, so some may be refused (RE_DECIDE, UNREACHABLE, NOT_APPLIED) or invisible to
// the caller (NOT_VISIBLE) while others land. A caller that cannot see the per-request outcomes can
// only announce a result it does not have.
export function bulkAction(requestIds, action, comments) {
  return function(dispatch) {
    dispatch({type: workflowActions.BULK_ACTION_REQUEST});
    return axios.post(`${process.env.REACT_APP_API_URL}/workflow/changes/bulk-action`,
        {requestIds, action, comments},
        {headers: authHeaders()},
    )
        .then((r) => r.data)
        .then((json) => {
          dispatch({type: workflowActions.BULK_ACTION_SUCCESS, payload: json});
          return json;
        })
        .catch((error) => {
          dispatch({type: workflowActions.BULK_ACTION_FAILURE, payload: error, error: true});
          return null;
        });
  };
}

export function loadNotifications({unreadOnly, page, limit} = {}) {
  return function(dispatch) {
    dispatch({type: workflowActions.LOAD_NOTIFICATIONS_REQUEST});
    const params = new URLSearchParams();
    if (unreadOnly) params.append('unreadOnly', 'true');
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/notifications?${params}`, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.LOAD_NOTIFICATIONS_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.LOAD_NOTIFICATIONS_FAILURE, payload: error, error: true}));
  };
}

export function loadUnreadCount() {
  return function(dispatch) {
    dispatch({type: workflowActions.LOAD_UNREAD_COUNT_REQUEST});
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/notifications/count`, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.LOAD_UNREAD_COUNT_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.LOAD_UNREAD_COUNT_FAILURE, payload: error, error: true}));
  };
}

export function markNotificationRead(notificationId) {
  return function(dispatch) {
    axios.put(`${process.env.REACT_APP_API_URL}/workflow/notifications/${notificationId}/read`, {}, {headers: authHeaders()})
        .then((r) => r.data)
        .then(() => dispatch({type: workflowActions.MARK_READ_SUCCESS, payload: {notificationId}}))
        .catch(() => {});
  };
}

export function markAllNotificationsRead() {
  return function(dispatch) {
    axios.put(`${process.env.REACT_APP_API_URL}/workflow/notifications/read-all`, {}, {headers: authHeaders()})
        .then(() => dispatch({type: workflowActions.MARK_ALL_READ_SUCCESS}))
        .catch(() => {});
  };
}

export function loadPermissions() {
  return function(dispatch) {
    dispatch({type: workflowActions.LOAD_PERMISSIONS_REQUEST});
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/permissions`, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.LOAD_PERMISSIONS_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.LOAD_PERMISSIONS_FAILURE, payload: error, error: true}));
  };
}

export function updatePermissions(roleId, permissions) {
  return function(dispatch) {
    axios.put(`${process.env.REACT_APP_API_URL}/workflow/permissions/${roleId}`, permissions, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.UPDATE_PERMISSIONS_SUCCESS, payload: json}))
        .catch(() => {});
  };
}

export function loadHistory(filters = {}) {
  return function(dispatch) {
    dispatch({type: workflowActions.LOAD_HISTORY_REQUEST});
    const params = new URLSearchParams();
    if (filters.entityType) params.append('entityType', filters.entityType);
    if (filters.entityId) params.append('entityId', filters.entityId);
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/history?${params}`, {headers: authHeaders()})
        .then((r) => r.data)
        .then((json) => dispatch({type: workflowActions.LOAD_HISTORY_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: workflowActions.LOAD_HISTORY_FAILURE, payload: error, error: true}));
  };
}

function triggerBlobDownload(blobData, contentType, fallbackFilename, disposition) {
  const filename = disposition ?
    disposition.split('filename=')[1].replace(/"/g, '') :
    fallbackFilename;
  const url = window.URL.createObjectURL(new Blob([blobData], {type: contentType}));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function downloadAuditReport(filters = {}) {
  return function(dispatch) {
    dispatch({type: workflowActions.DOWNLOAD_AUDIT_REPORT_REQUEST});
    const params = new URLSearchParams();
    if (filters.instanceId) params.append('instanceId', filters.instanceId);
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/reports/audit?${params}`, {
      headers: {'x-access-token': getAccessToken()},
      responseType: 'blob',
      timeout: 60000,
    })
        .then((response) => {
          triggerBlobDownload(response.data, 'application/pdf', 'workflow-audit-report.pdf', response.headers['content-disposition']);
          dispatch({type: workflowActions.DOWNLOAD_AUDIT_REPORT_SUCCESS});
        })
        .catch((error) => dispatch({type: workflowActions.DOWNLOAD_AUDIT_REPORT_FAILURE, payload: error, error: true}));
  };
}

export function downloadDetailedReport(filters = {}) {
  return function(dispatch) {
    dispatch({type: workflowActions.DOWNLOAD_DETAILED_REPORT_REQUEST});
    const params = new URLSearchParams();
    if (filters.requestId) params.append('requestId', filters.requestId);
    if (filters.instanceId) params.append('instanceId', filters.instanceId);
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/reports/detailed?${params}`, {
      headers: {'x-access-token': getAccessToken()},
      responseType: 'blob',
      timeout: 60000,
    })
        .then((response) => {
          triggerBlobDownload(response.data, 'application/pdf', 'workflow-detailed-report.pdf', response.headers['content-disposition']);
          dispatch({type: workflowActions.DOWNLOAD_DETAILED_REPORT_SUCCESS});
        })
        .catch((error) => dispatch({type: workflowActions.DOWNLOAD_DETAILED_REPORT_FAILURE, payload: error, error: true}));
  };
}

export function downloadSummaryReport(filters = {}) {
  return function(dispatch) {
    dispatch({type: workflowActions.DOWNLOAD_SUMMARY_REPORT_REQUEST});
    const params = new URLSearchParams();
    if (filters.instanceId) params.append('instanceId', filters.instanceId);
    axios.get(`${process.env.REACT_APP_API_URL}/workflow/reports/summary?${params}`, {
      headers: {'x-access-token': getAccessToken()},
      responseType: 'blob',
      timeout: 60000,
    })
        .then((response) => {
          triggerBlobDownload(response.data, 'application/pdf', 'workflow-summary-report.pdf', response.headers['content-disposition']);
          dispatch({type: workflowActions.DOWNLOAD_SUMMARY_REPORT_SUCCESS});
        })
        .catch((error) => dispatch({type: workflowActions.DOWNLOAD_SUMMARY_REPORT_FAILURE, payload: error, error: true}));
  };
}

// Deep-link from notification: load a single CR by id (works for IMPLEMENTED CRs not
// in the active list). The caller consumes the returned promise directly to open the
// detail drawer, so this thunk does not dispatch into shared redux state.
export function loadChangeRequestById(requestId) {
  return function() {
    return axios.get(`${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}`, {headers: authHeaders()})
        .then((r) => (r.data && r.data.response && r.data.response.changeRequest) || null);
  };
}
